var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#EF3145"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5172 4C11.7586 4 12 4.17897 12 4.48322V7.0962C12 7.27517 11.8448 7.43624 11.6552 7.43624H9.15517C8.86207 7.43624 8.68966 7.18568 8.68966 6.95302C8.68966 6.82774 8.72414 6.70246 8.82759 6.61298L9.60345 5.78971C9.12069 5.37808 8.5 5.14541 7.84483 5.14541C6.32759 5.14541 5.10345 6.434 5.10345 8.00895C5.10345 9.58389 6.32759 10.8546 7.84483 10.8546C9.12069 10.8546 9.39655 10.1745 9.84483 10.1745C10.1552 10.1745 10.3793 10.443 10.3793 10.7472C10.3793 11.3736 8.98276 12 7.84483 12C5.72414 12 4 10.2103 4 8.00895C4 5.78971 5.72414 4 7.86207 4C8.7931 4 9.68966 4.35794 10.3793 4.98434L11.2069 4.14318C11.2931 4.03579 11.4138 4 11.5172 4Z",
    fill: "#FEEEF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/Reload.ef487342267de20faafa50362740ab66.svg";
export { ForwardRef as ReactComponent };